import React from 'react';
import handleRenderProp from 'utils/handleRenderProp';
import RenderPropType from 'utils/ts/RenderPropType';


const MetaGrid: React.SFC<MetaGridProps> = ({ items, renderItem }) => (
  <div className="meta-grid">
    <ul className="meta-grid__list">
      {items.map(item => (
        <li key={item.key} className="meta-grid__item">
          {handleRenderProp(renderItem, item)}
        </li>
      ))}
    </ul>
  </div>
);

MetaGrid.defaultProps = {
  items: [],
};

interface MetaGridProps {
  items: {
    key: string;
    [x: string]: any;
  }[];
  renderItem: RenderPropType;
}

export default MetaGrid;

